<template>
  <div class="l-container font-Spectral">
    <AtomsJiji :env="env" />
    <OrganismsPagesEnHeader class="l-header" />
    <main class="l-main">
      <slot />
    </main>
    <OrganismsPagesEnGlobalSidebar :on-close="hideGlobalSidebar" :should-show="shouldShowGlobalSidebar" />
    <OrganismsPagesEnFooter />
    <!-- ヘッダー、グローバルサイドバーから体験検索モーダルを呼ぶため、EnGlobalにて共通コンポーネントとして扱っている -->
    <SearchExperiencesModal :on-close="close" :should-show-modal="isOpen" />
    <!-- キーワード検索モーダル（ヘッダー・サイドバーの「Search」ボタンから起動）。
         開閉状態とモーダル本体は wabunka-src/features/Search 配下で自己完結する -->
    <KeywordSearchModalMount />
  </div>
</template>

<script setup lang="ts">
import SearchExperiencesModal from '@/components/organisms/SearchExperiencesModal/SearchExperiencesModal.vue';
import { useGlobalModal } from '@/composables/ui/useGlobalModal';
import { useGlobalSidebar } from '@/composables/ui/useGlobalSidebar';
import { NavigationFeaturedKey, useFetchNavigationFeatured } from '@/wabunka-src/common/features/Featured/composables/query/useNavigationFeatured';
import KeywordSearchModalMount from '@/wabunka-src/features/Search/components/general/KeywordSearchModalMount.vue';

const { isOpen: shouldShowGlobalSidebar, close: hideGlobalSidebar } = useGlobalSidebar();
const { close, isOpen } = useGlobalModal('searchExperiencesModal');
const runtimeConfig = useRuntimeConfig();
const env = runtimeConfig.public.env;

// ナビゲーション用 Featured データを取得し、子コンポーネント（EnHeader / EnGlobalSidebar）へ provide する
const navigationFeatured = await useFetchNavigationFeatured();
provide(NavigationFeaturedKey, navigationFeatured);
</script>

<style lang="scss" scoped>
.l-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.l-main {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 50px;

  @media only screen and (min-width: 992px) {
    margin-top: 70px;
  }
}

.l-header {
  position: fixed;
  top: 0;
}
</style>
